"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _AbstractDeviceFrame = _interopRequireDefault(require("./AbstractDeviceFrame"));

var _colors = require("HubStyleTokens/colors");

var TabletPortraitFrame = function TabletPortraitFrame(props) {
  return _react.default.createElement("svg", props, _react.default.createElement("g", {
    transform: "rotate(90 194 195)",
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("path", {
    fill: _colors.GYPSUM,
    stroke: _colors.BATTLESHIP,
    d: "M-.5 15.994C-.5 6.884 6.886-.5 16.004-.5h484.992c9.112 0 16.504 7.391 16.504 16.494v356.012c0 9.11-7.386 16.494-16.504 16.494H16.004C6.892 388.5-.5 381.109-.5 372.006V15.994zm25 2.001v352.01a5.502 5.502 0 0 0 5.495 5.495h469.01a5.5 5.5 0 0 0 5.495-5.495V17.995a5.502 5.502 0 0 0-5.495-5.495H29.995a5.5 5.5 0 0 0-5.495 5.495z"
  }), _react.default.createElement("circle", {
    fill: _colors.BATTLESHIP,
    cx: "12",
    cy: "194",
    r: "4"
  })));
};

var TabletLandscapeFrame = function TabletLandscapeFrame(props) {
  return _react.default.createElement("svg", props, _react.default.createElement("g", {
    transform: "translate(1 1)",
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("path", {
    fill: _colors.GYPSUM,
    stroke: _colors.BATTLESHIP,
    d: "M-.5 15.994C-.5 6.884 6.886-.5 16.004-.5h484.992c9.112 0 16.504 7.391 16.504 16.494v356.012c0 9.11-7.386 16.494-16.504 16.494H16.004C6.892 388.5-.5 381.109-.5 372.006V15.994zm25 2.001v352.01a5.502 5.502 0 0 0 5.495 5.495h469.01a5.5 5.5 0 0 0 5.495-5.495V17.995a5.502 5.502 0 0 0-5.495-5.495H29.995a5.5 5.5 0 0 0-5.495 5.495z"
  }), _react.default.createElement("circle", {
    fill: _colors.BATTLESHIP,
    cx: "12",
    cy: "194",
    r: "4"
  })));
};

var TABLET_DEVICE_SPECS = {
  tabletPortrait: {
    Template: TabletPortraitFrame,
    top: 25.5,
    right: 13.5,
    bottom: 13.5,
    left: 13.5,
    height: 519,
    width: 390
  },
  tabletLandscape: {
    Template: TabletLandscapeFrame,
    top: 13.5,
    right: 13.5,
    bottom: 13.5,
    left: 25.5,
    height: 390,
    width: 519
  }
};

var UIDeviceFrameTablet = function UIDeviceFrameTablet(props) {
  var children = props.children,
      className = props.className,
      contentClassName = props.contentClassName,
      orientation = props.orientation,
      rest = (0, _objectWithoutProperties2.default)(props, ["children", "className", "contentClassName", "orientation"]);
  var computedSpecs = orientation === 'landscape' ? TABLET_DEVICE_SPECS.tabletLandscape : TABLET_DEVICE_SPECS.tabletPortrait;
  return _react.default.createElement(_AbstractDeviceFrame.default, (0, _extends2.default)({}, rest, {
    className: className,
    contentClassName: contentClassName,
    spec: computedSpecs,
    orientation: orientation
  }), children);
};

UIDeviceFrameTablet.propTypes = {
  children: _react.PropTypes.node.isRequired,
  contentClassName: _react.PropTypes.string,
  orientation: _react.PropTypes.oneOf(['portrait', 'landscape'])
};
UIDeviceFrameTablet.defaultProps = {
  orientation: 'portrait'
};
UIDeviceFrameTablet.displayName = 'UIDeviceFrameTablet';
var _default = UIDeviceFrameTablet;
exports.default = _default;
module.exports = exports.default;